import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const RecentArtists = ({ artists = [] }) => {
  const navigate = useNavigate();

  const handleViewArtist = (artistId) => {
    navigate(`/artist-detail-editor-view?id=${artistId}`);
  };

  const getArtistTypeIcon = (type) => {
    switch (type?.toLowerCase()) {
      case 'music':
        return 'Music';
      case 'visual':
        return 'Palette';
      case 'model':
        return 'Camera';
      case 'actor':
        return 'Video';
      default:
        return 'User';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg elevation-1">
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-text-primary">Recently Viewed</h3>
          <Button variant="ghost" size="sm" iconName="MoreHorizontal" />
        </div>
      </div>
      <div className="p-4">
        {artists?.length === 0 ? (
          <div className="text-center py-6">
            <Icon name="Clock" size={32} className="text-text-secondary mx-auto mb-2" />
            <p className="text-sm text-text-secondary">No recent activity</p>
          </div>
        ) : (
          <div className="space-y-3">
            {artists?.map((artist) => (
              <div
                key={artist?.id}
                className="flex items-center space-x-3 p-2 rounded-lg hover:bg-muted transition-smooth cursor-pointer"
                onClick={() => handleViewArtist(artist?.id)}
              >
                <div className="relative">
                  <Image
                    src={artist?.avatar}
                    alt={artist?.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-card border border-border rounded-full flex items-center justify-center">
                    <Icon 
                      name={getArtistTypeIcon(artist?.type)} 
                      size={10} 
                      className="text-text-secondary" 
                    />
                  </div>
                </div>
                
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-text-primary truncate">
                    {artist?.name}
                  </p>
                  <p className="text-xs text-text-secondary">
                    Viewed {artist?.lastViewed}
                  </p>
                </div>
                
                <div className="flex items-center space-x-1">
                  {artist?.hasUpdates && (
                    <div className="w-2 h-2 bg-accent rounded-full" />
                  )}
                  <Icon name="ChevronRight" size={14} className="text-text-secondary" />
                </div>
              </div>
            ))}
          </div>
        )}
        
        {artists?.length > 0 && (
          <div className="mt-4 pt-3 border-t border-border">
            <Button
              variant="ghost"
              size="sm"
              fullWidth
              iconName="ArrowRight"
              iconPosition="right"
            >
              View All Recent
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentArtists;